import { render, staticRenderFns } from "./reportCase.vue?vue&type=template&id=0cb62ebe"
import script from "./reportCase.vue?vue&type=script&lang=js"
export * from "./reportCase.vue?vue&type=script&lang=js"
import style0 from "./reportCase.vue?vue&type=style&index=0&id=0cb62ebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports